<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>총괄표</h3>
            </div>
            <img width="100%" src="/src/assets/images/lecture_curriculum.png" alt="교육 프로그램 총괄표" />



            <div class="title page-title">
                <h3>선발 절차 / 교육 특전</h3>
            </div>
            <div class="process-wrap">
                <img width="100%" src="/src/assets/images/lecture_process.png" alt="선발 절차/ 교육 특전" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    hr {
        background-color: $gray-regular_color;
        height: 1px;
        border: 0;
        line-height: inherit;
        margin: 20px 0 0;
    }

    .process-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        & > div {
            &.left-area {
                width: 828px;
                border-right: $border_line;
                padding-right: 73px;
            }
            &.right-area {
                width: 614px;
                padding-left: 73px;
                .title-box {
                    margin-bottom: 10px;
                }
            }
        }
        .title-box {
            background-color: $gray-light_color;
            @include font-size_lg;
            padding: 10px 20px;
            margin-bottom: 20px;
            &.blue {
                background-color: $blue_color;
                color: $gray-thin_color;
            }
            small {
                @include font-size_sm;
                margin-left: 4px;
            }
        }
        .text-box {
            position: relative;
            height: 97px;
            @include font-size_md;
            background-color: $gray-light_color;
            margin-top: 6px;
            p {
                position: absolute;
                top: 50%;
                left: 40px;
                transform: translateY(-50%);
                i {
                    position: absolute;
                    font-style: normal;
                    left: -20px;
                }
            }
        }
        ul {
            display: flex;
            align-items: center;
            padding: 0 20px 80px;
            &:last-child {
                padding-bottom: 0;
            }
            li {
                position: relative;
                @include font-size_md;
                text-align: center;
                margin-right: 84px;
                img {
                    display: block;
                    margin-bottom: 10px;
                }
                &:last-child {
                    color: $blue_color;
                    font-weight: 700;
                    &:after {
                        display: none;
                    }
                }
                &:after {
                    content: "";
                    position: absolute;
                    top: 40px;
                    right: -66px;
                    width: 48px;
                    height: 26px;
                    background: url(/src/assets/images/lecture-step_arrow.png) no-repeat center;
                }
            }
        }
    }
</style>